module.exports = "<div class=\"progress\" [style.width]=\"percentage + '%'\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/atoms/alg-progress-bar/alg-progress-bar.component.html
// module id = ./src/app/components/atoms/alg-progress-bar/alg-progress-bar.component.html
// module chunks = main